import BaseTool from '../../baseComponents/BaseTool';
import SliceWidget from './SliceWidget';
import PointWidget from './PointWidget';
import ViewWidget from './ViewWidget';
import {logScaleVariables, radScaleVariables, vectorColormaps, vectorVariables} from "../../../utils/globals";
import {memo} from "react";
import cloneDeep from "lodash/cloneDeep";

const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  point_widget: {},
  view_widget: {},
}

const DEFAULTS= {
  sim_widget: {
    domain: 'cor',
    variable: 'br',
    time_of_interest: null,
  },
  slice_widget: {
    slice: 'r',
    slice_param1: null,
    abs_transform: false,
    log_transform: false,
    rad_transform: true,
    rad_transform_exponent: 2,
    units: 'real',
    show_text: true,
    color: 'psi_blue_red'
  },
  point_widget: {
    query_point: false,
    point_xvalue: null,
    point_yvalue: null,
    line_width: 0.8,
    line_style: 'dashed',
    marker_symbol: 'o',
    color: '#A2000B',
    show_point: true,
    show_lines: true,
    show_text: true,
  },
  view_widget: {
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    zaxis_min: null,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: true,
    symmetric_value: null,
    grid: null,
  },
}

const sharedData = {
  slice_widget: {slice: null}
}

const flagTriggers = {
  sim_widget: {variable: true},
}

const flagDependencies = {
  slice_widget: {color: null, log_transform: null, rad_transform: null, rad_transform_exponent: null},
  view_widget: {symmetric: null}
}

const flagValidators = (widget, k, v, dependencies) => {
  const modifiedParams = cloneDeep(PARAM_SCHEMA);

  const isVectorVariable = vectorVariables.includes(v);
  const isVectorColormap= vectorColormaps.includes(dependencies.slice_widget.color);
  const isSymmetric = dependencies.view_widget.symmetric;
  const isRadScaleVariable = radScaleVariables.includes(v);
  const isLogScaleVariable = logScaleVariables.includes(v);

  if (isVectorVariable !== isVectorColormap) {
    modifiedParams.slice_widget.color = isVectorVariable
      ? "psi_blue_red"
      : "rainbow";
  }
  
  if (isVectorVariable !== isSymmetric) {
    modifiedParams.view_widget.symmetric = isVectorVariable;
    modifiedParams.view_widget.symmetric_value = null;
    modifiedParams.view_widget.zaxis_min = null;
    modifiedParams.view_widget.zaxis_max = null;
  }
  
  if (isLogScaleVariable !== dependencies.slice_widget.log_transform) {
    modifiedParams.slice_widget.log_transform = isLogScaleVariable;
  }
  
  if (isRadScaleVariable !== dependencies.slice_widget.rad_transform) {
    modifiedParams.slice_widget.rad_transform = isRadScaleVariable;
    modifiedParams.slice_widget.rad_transform_exponent = 2;
  }

  modifiedParams[widget][k] = v;
  return { widget_: "_", params_: modifiedParams };
};

const Plot2d = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='plot2d'
        toolName='PLOT2D'
        sharedDeps={sharedData}
        flagTriggers={flagTriggers}
        flagDeps={flagDependencies}
        flagValidators={flagValidators}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        pointWidget={PointWidget}
        viewWidget={ViewWidget}
      />
    </>

  )
}

export default memo(Plot2d);